// @ts-nocheck
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { ChevronRightOffset } from "@store/Library/Components/Toolkit/Icons/ChevronRight";
import { linkStyles } from "@store/Themes/common/mixins/link";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { inlineSeparatorStyles } from "@store/Themes/common/mixins/typography";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { IconOffset } from "@toolkit/Framework/Types/Icon";
import { focusUpdateStyles, iconColorStyles, iconScalableStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

export interface MenuPanelRowStylesOptions {
    iconPosition?: "left" | "right";
    iconOffset?: IconOffset;
    color?: string;
    hoverColor?: string | null;
    hoverUnderline?: boolean;
    accentColor?: string | null;
    accentHoverColor?: string | null;
    backgroundColor?: string;
    backgroundHoverColor?: string | null;
    borderColor?: string;
}

export const menuPanelRowStyles = (options?: MenuPanelRowStylesOptions) => {
    const iconPosition = options?.iconPosition || "left";
    const iconOffset = options?.iconOffset || ChevronRightOffset;
    const color = options?.color || "menu.mainNavigation.contrast";
    const hoverColor = options?.hoverColor === null ? color : options?.hoverColor || "menu.mainNavigation.hover";
    const hoverUnderline = options?.hoverUnderline ?? true;
    const accentColor = options?.accentColor === null ? color : options?.accentColor || "menu.mainNavigation.accent";
    const accentHoverColor =
        options?.accentHoverColor === null
            ? accentColor
            : options?.accentHoverColor || "menu.mainNavigation.accentHover";
    const backgroundColor = options?.backgroundColor || "transparent";
    const backgroundHoverColor = options?.backgroundHoverColor || backgroundColor;
    const borderColor = options?.borderColor || "menu.mainNavigation.separator";
    const spacingSide = iconPosition === "left" ? "right" : "left";
    const transition = transitionHoverStyles("color", "background-color");

    return css`
        ${linkStyles(color, hoverColor, false, hoverUnderline)}
        ${focusUpdateStyles(true)}
        width: 100%;
        padding: ${x => x.theme.design.menu.panel.rowPadding};
        background-color: ${getColor(backgroundColor)};
        border-bottom: 1px solid ${getColor(borderColor)};
        transition: ${transition};

        ${({ theme }) => css`
            font-size: ${theme.design.typography.size.smaller};
            font-weight: ${theme.design.typography.weight.bold};
            line-height: ${theme.design.typography.lineHeight.small};
        `}

        ${IconWrapper} {
            ${iconColorStyles(accentColor, transition)}
            flex-shrink: 0;
        }

        > ${IconWrapper} {
            ${iconScalableStyles("1.15em", iconOffset)}
            margin-${spacingSide}: 0.6em;
            top: auto;
        }

        &:hover,
        &:active {
            background-color: ${getColor(backgroundHoverColor)};

            ${IconWrapper} {
                ${iconColorStyles(accentHoverColor, transition)}
            }
        }
    `;
};

export const menuPanelRowResetStyles = () => css`
    padding: 0;
    color: inherit;
    background-color: transparent;
`;

export const menuPanelContentRowStyles = () => css`
    padding: ${x => x.theme.design.menu.panel.rowPadding};
    flex-direction: column;
    align-items: stretch;
    color: inherit;
    background-color: transparent;
    line-height: ${x => x.theme.design.typography.lineHeight.base};
    outline: none !important;
    cursor: default;

    &:hover,
    &:active {
        color: inherit;
    }
`;

export const menuSecondaryNavigationItemStyles = () => css`
    ${({ theme }) => {
        const { itemSpacing, separatorSize } = theme.design.menu.secondaryNavigation;

        return css`
            line-height: ${theme.design.typography.lineHeight.base};

            ${breakpointValues(
                itemSpacing.map(x =>
                    x !== null
                        ? inlineSeparatorStyles({
                              spacing: `${x}`,
                              width: separatorSize,
                              color: "currentColor",
                          })
                        : null,
                ),
            )}
        `;
    }}
`;
